import { TuiInput, TuiTextfield } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestDTO } from '@core/types/Request';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  SubjName = 'subjName',
  SubjInn = 'subjInn',
  SubjFullname = 'subjFullname',
  SubjPhone = 'subjPhone',
}

type FormType = Pick<
  RequestDTO,
  'subjName' | 'subjInn' | 'subjFullname' | 'subjPhone'
>;

@Component({
  selector: 'x-request-form-common-lessee',
  imports: [TuiTextfield, ReactiveFormsModule, TuiInput, TranslatePipe],
  templateUrl: './request-form-common-lessee.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonLesseeComponent implements OnInit {
  protected readonly permissionService = inject(OutkeepPermissionService);
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group<FormType>({
    [FormFields.SubjName]: '',
    [FormFields.SubjInn]: '',
    [FormFields.SubjFullname]: '',
    [FormFields.SubjPhone]: '',
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('lessee', this.formGroup);
  }
}
